import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * AuthCallback - Handles OAuth redirect from Google
 *
 * Two possible paths:
 * 1. /auth/callback?token=xxx - Success, store token and redirect to home
 * 2. /auth/success?token=xxx - Alternative success path from backend
 */
function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { handleAuthCallback } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (error) {
      // Redirect to login with error
      navigate(`/login?error=${error}`);
      return;
    }

    if (token) {
      // Store token and return the user to where they were (deep-link preserved
      // across the OAuth round-trip), else home.
      handleAuthCallback(token);
      let returnTo = '/';
      try {
        returnTo = sessionStorage.getItem('returnTo') || '/';
        sessionStorage.removeItem('returnTo');
      } catch (e) { /* sessionStorage unavailable */ }
      navigate(returnTo);
    } else {
      // No token, redirect to login
      navigate('/login?error=no_token');
    }
  }, [searchParams, navigate, handleAuthCallback]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #1a1f3a 0%, #2a5298 100%)'
    }}>
      <div style={{
        background: 'white',
        padding: '48px',
        borderRadius: '16px',
        textAlign: 'center'
      }}>
        <div style={{
          width: '48px',
          height: '48px',
          border: '3px solid #e5e7eb',
          borderTopColor: '#2a5298',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
          margin: '0 auto 16px'
        }} />
        <p style={{ color: '#6c757d', margin: 0 }}>
          Completing sign in...
        </p>
      </div>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default AuthCallback;
